import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { isPresent } from 'helpers/verify';

export const CreditCount = ({ creditsRemaining }) =>
  isPresent(creditsRemaining) && (
    <div className="header__credit-count">
      <a href="/settings/membership ">
        <FormattedMessage
          id="nav.mobile.credits"
          defaultMessage="{creditsRemaining, plural, one {# credit} other {# credits}}"
          values={{ creditsRemaining }}
        />
      </a>
    </div>
  );

CreditCount.propTypes = {
  creditsRemaining: PropTypes.number,
};
